import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function About() {
  const [titleVisible, setTitleVisible] = useState(false);
  const [leftVisible, setLeftVisible] = useState(false);
  const [rightVisible, setRightVisible] = useState(false);
  const titleRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target === titleRef.current) setTitleVisible(true);
            if (entry.target === leftRef.current) setLeftVisible(true);
            if (entry.target === rightRef.current) setRightVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    if (leftRef.current) observer.observe(leftRef.current);
    if (rightRef.current) observer.observe(rightRef.current);

    return () => observer.disconnect();
  }, []);

  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 50%, rgba(71, 85, 105, 0.85) 100%), url("https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=80") center/cover',
      padding: '140px 0 100px',
      position: 'relative',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at top right, rgba(59, 130, 246, 0.15) 0%, transparent 50%)',
      pointerEvents: 'none'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 800,
      color: '#ffffff',
      marginBottom: '20px',
      textShadow: '0 4px 12px rgba(0,0,0,0.3)',
      letterSpacing: '-0.02em'
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#e2e8f0',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.6
    },
    slideIn: {
      opacity: titleVisible ? 1 : 0,
      transform: titleVisible ? 'translateY(0)' : 'translateY(-50px)',
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
    },
    slideFromLeft: {
      opacity: leftVisible ? 1 : 0,
      transform: leftVisible ? 'translateX(0)' : 'translateX(-100px)',
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
    },
    slideFromRight: {
      opacity: rightVisible ? 1 : 0,
      transform: rightVisible ? 'translateX(0)' : 'translateX(100px)',
      transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <h1 style={styles.heroTitle}>About Manami Trading</h1>
              <p style={styles.heroSubtitle}>
                Building trusted partnerships through quality products and reliable service across Namibia and beyond
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Content Section */}
      <div style={{ padding: '80px 0', background: '#f8fafc' }}>
        <Container>
          <Row>
            <Col md={12} ref={titleRef} style={styles.slideIn}>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e40af', marginBottom: '24px', textAlign: 'center' }}>Who We Are</h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '60px', color: '#475569', textAlign: 'center', maxWidth: '900px', margin: '0 auto 60px' }}>
                Manami Trading is a growing trading and distribution company committed to 
                delivering quality products, efficient supply solutions, and dependable customer 
                service. We work closely with suppliers and customers to ensure consistency, 
                transparency, and value across our operations.
              </p>
            </Col>
          </Row>
          
          <Row>
            <Col md={6} className="mb-4" ref={leftRef} style={styles.slideFromLeft}>
              <div style={{ background: 'white', padding: '40px', borderRadius: '12px', height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <h3 style={{ color: '#2563eb', fontWeight: 700, fontSize: '1.8rem', marginBottom: '16px' }}>Our Mission</h3>
                <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#64748b' }}>
                  To provide reliable, affordable, and quality products through efficient sourcing, 
                  logistics, and customer-focused service.
                </p>
              </div>
            </Col>
            <Col md={6} className="mb-4" ref={rightRef} style={styles.slideFromRight}>
              <div style={{ background: 'white', padding: '40px', borderRadius: '12px', height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <h3 style={{ color: '#2563eb', fontWeight: 700, fontSize: '1.8rem', marginBottom: '16px' }}>Our Vision</h3>
                <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#64748b' }}>
                  To become a trusted trading partner in Namibia and the region, known for integrity, 
                  efficiency, and sustainable business practices.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default About;
